import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {WHITE} from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            backgroundColor: WHITE,
            padding: '25px 24px',
            borderRadius: 3,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxHeight: '80vh',
            overflowY: 'auto',
        },
        closeButton: {
            alignSelf: 'flex-end',
            width: 13,
            height: 13,
            position: 'absolute',
            top: 10,
            right: 10,
        },
        [theme.breakpoints.down('sm')]: {
            container: {
                width: '95vw',
            },
        },
    }),
);

export default useStyles;
